import { render, staticRenderFns } from "./productsRefnat.vue?vue&type=template&id=038581f7&"
import script from "./productsRefnat.vue?vue&type=script&lang=js&"
export * from "./productsRefnat.vue?vue&type=script&lang=js&"
import style0 from "./productsRefnat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports